import React from 'react'

import SeoHeadings from '../seoHeadings/seoHeadings'

const ResultsInfo = ({ locationParams, seoMeta, styles, TagName }) => {
  const shouldShowSubheading =
    (!locationParams.page ||
      (locationParams.page && locationParams.page === '1')) &&
    seoMeta.subHeading

  return (
    <SeoHeadings
      TagName={TagName}
      heading={seoMeta.heading}
      subHeading={shouldShowSubheading && seoMeta.subHeading}
      searchDescription={seoMeta.searchDescription}
      styles={styles}
    />
  )
}

export default ResultsInfo
